{{ msg | translate }}
<button (click)="reload()" ui-button-secondary type="button">
  {{ 'UPDATE_ALERT.BUTTON' | translate }}
</button>
